import React, { createContext, useState, useEffect } from 'react';
import { instalaGuarda, podeVerComo, sessaoDe } from './verComo';

export const GlobalContext = createContext({});

const STORAGE_KEY = 'centralbabita.user';
// Modo "ver como" (lib/verComo.js): a conta REAL da TI fica guardada aqui enquanto `user` e o
// usuario que ela esta vendo. Sobrevive ao F5 junto com a sessao.
const STORAGE_REAL = 'centralbabita.user.real';

function leStorage(chave) {
    try {
        const raw = localStorage.getItem(chave);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function GlobalProvider({ children }) {
    const [user, setUser] = useState(() => leStorage(STORAGE_KEY));
    const [realUser, setRealUser] = useState(() => {
        const r = leStorage(STORAGE_REAL);
        if (r) instalaGuarda(true);   // ja na 1a renderizacao: nenhuma tela grava antes do guarda
        return r;
    });

    const [palette, setPalette] = useState(() => localStorage.getItem('centralbabita.palette') || 'atelier');
    const [mode, setMode] = useState(() => localStorage.getItem('centralbabita.mode') || 'light');

    useEffect(() => {
        if (user) localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
        else localStorage.removeItem(STORAGE_KEY);
    }, [user]);

    useEffect(() => {
        if (realUser) localStorage.setItem(STORAGE_REAL, JSON.stringify(realUser));
        else localStorage.removeItem(STORAGE_REAL);
        instalaGuarda(!!realUser);
    }, [realUser]);

    useEffect(() => {
        const root = document.documentElement;
        if (palette === 'atelier') root.removeAttribute('data-palette');
        else root.setAttribute('data-palette', palette);
        localStorage.setItem('centralbabita.palette', palette);
    }, [palette]);

    useEffect(() => {
        const root = document.documentElement;
        if (mode === 'light') root.removeAttribute('data-mode');
        else root.setAttribute('data-mode', mode);
        localStorage.setItem('centralbabita.mode', mode);
    }, [mode]);

    function login(u) { setRealUser(null); setUser(u); }
    function logout() { setRealUser(null); setUser(null); }

    // Ver o sistema com o acesso de `alvo` (um usuario da lista de Logins). So TI/Administrador.
    function verComo(alvo) {
        const real = realUser || user;
        if (!alvo || !podeVerComo(real)) return false;
        instalaGuarda(true);
        setRealUser(real);
        setUser(sessaoDe(alvo, real));
        return true;
    }
    function sairVerComo() {
        if (!realUser) return;
        setUser(realUser);
        setRealUser(null);
    }

    return (
        <GlobalContext.Provider value={{ user, setUser, login, logout, palette, setPalette, mode, setMode, realUser, verComo, sairVerComo }}>
            {children}
        </GlobalContext.Provider>
    );
}
